import { render, staticRenderFns } from "./pharmacist.vue?vue&type=template&id=8020834e&scoped=true&"
import script from "./pharmacist.vue?vue&type=script&lang=js&"
export * from "./pharmacist.vue?vue&type=script&lang=js&"
import style0 from "./pharmacist.vue?vue&type=style&index=0&id=8020834e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8020834e",
  null
  
)

export default component.exports